import type {
  IProblemRecord,
  ISection,
  ISubnavItem,
  ITableBlock,
  ITableColumn,
  ITableUI,
} from "../../../shared/ui/data-table/model/data-table-contract";

export type {
  IProblemRecord,
  ISection,
  ISubnavItem,
  ITableBlock,
  ITableColumn,
  ITableUI,
};

export const getEncounterDocs = (store: {
  encounters: {
    encounterDocs: { data: IProblemRecord | null };
  };
}) => store.encounters.encounterDocs.data;
